@if (menuItem) {
<app-gold-line input_position="start" />
<div class="layout">
  <ng-container
    *ngIf="languageService.currentLanguage$ | async as currentLanguage"
  >
    @if(currentLanguage === 'Ar'){
    <div class="category_card">
      <div
        class="category_card__image"
        [style.backgroundImage]="'url(' + menuItem.imageUrl + ')'"
      ></div>

      <div class="category_card__container inactive" #container>
        <div
          class="category_card__container__title category_card__container__title--ar"
        >
          {{ menuItem.nameAr }}
        </div>
        <div
          class="category_card__container__desc category_card__container__desc--ar"
        >
          {{ description() }} 
        </div>
        <div class="category_card__container__button">
          <app-learn-more [menuItemID]="menuItem.id" />
        </div>
        <div class="category_card__container__counterAndprice">
          <app-counter
            input_color="blue"
            [id]="menuItem.id"
            [price]="menuItem.priceAr"
          />
          <app-price-user
            [input_price_tlValue]="menuItem.priceAr"
            [input_price_usdValue]="amountInUSD"
            class="price"
            input_type="jd"
          />
        </div>
      </div>
    </div>
    } @else if(currentLanguage === 'En'){
    <div class="category_card">
      <div
        class="category_card__image"
        [style.backgroundImage]="'url(' + menuItem.imageUrl + ')'"
      ></div>

      <div class="category_card__container inactive" #container>
        <div class="category_card__container__title">{{ menuItem.nameEn }}</div>
        <div class="category_card__container__desc">{{ description() }} </div>
        <div class="category_card__container__button">
          <app-learn-more [menuItemID]="menuItem.id" />
        </div>
        <div class="category_card__container__counterAndprice">
          <app-counter
            input_color="blue"
            [id]="menuItem.id"
            [price]="menuItem.priceEn"
          />
          <app-price-user
            [input_price_tlValue]="menuItem.priceEn"
            [input_price_usdValue]="amountInUSD"
            class="price"
            input_type="jd"
          />
        </div>
      </div>
    </div>
    } @else if(currentLanguage === 'Tr'){
    <div class="category_card">
      <div
        class="category_card__image"
        [style.backgroundImage]="'url(' + menuItem.imageUrl + ')'"
      ></div>

      <div class="category_card__container inactive" #container>
        <div class="category_card__container__title">{{ menuItem.nameTr }}</div>
        <div class="category_card__container__desc">{{ description() }} </div>
        <div class="category_card__container__button">
          <app-learn-more [menuItemID]="menuItem.id" />
        </div>
        <div class="category_card__container__counterAndprice">
          <app-counter
            input_color="blue"
            [id]="menuItem.id"
            [price]="menuItem.priceTr"
          />
          <app-price-user
            [input_price_tlValue]="menuItem.priceTr"
            [input_price_usdValue]="amountInUSD"
            class="price"
            input_type="jd"
          />
        </div>
      </div>
    </div>
    }
  </ng-container>
</div>
<app-gold-line input_position="end" />
}
